import { MainMenuObject } from 'features/menu/components/menu-tile-grid/menu-tile/types';

import { ICombo, IItem, IPicker, MenuObject } from '@rbi-ctg/menu';
import { useFormatCalories } from 'hooks/use-format-calories';
import { useMainMenuContext } from 'state/menu/main-menu';
import { isItem, isPicker } from 'utils/menu';
import { formatCalorieRange } from 'utils/menu/calories';

interface IUseCalories {
  (): (comboOrItem: ICombo | IItem | IPicker | MainMenuObject) => string;
}

export const useCalories: IUseCalories = () => {
  const { getCalories } = useMainMenuContext();
  const formatCalories = useFormatCalories();

  return comboOrItem => {
    let formattedCalories: string | null | undefined = '';
    const calories = getCalories(comboOrItem as MenuObject);

    if (!calories) {
      return '';
    }

    if (isItem(comboOrItem) || isPicker(comboOrItem)) {
      formattedCalories = formatCalories(calories.default ?? null);
    } else {
      formattedCalories = formatCalorieRange({
        min: Number(calories.min),
        max: Number(calories.max),
        formatFn: formatCalories,
      });
    }

    return String(formattedCalories);
  };
};
